import { render } from "./ArtikelEvent.vue?vue&type=template&id=5e65f7a8"
import script from "./ArtikelEvent.vue?vue&type=script&lang=js"
export * from "./ArtikelEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__